import i18n from "../i18n";

export function timeAgo(ts) {
  if (!ts) return "";
  const d = new Date(ts);
  const now = new Date();
  const diffMs = Math.max(0, now - d);
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return i18n.t("common.justNow");
  if (mins < 60) return i18n.t("common.minutesAgo", { count: mins });
  const hours = Math.floor(mins / 60);
  if (hours < 24) return i18n.t("common.hoursAgo", { count: hours });
  const days = Math.floor(hours / 24);
  if (days === 1) return i18n.t("common.yesterday");
  return i18n.t("common.daysAgo", { count: days });
}
